import { useGetListCompany } from "./../../api/company";

export const useCompany = (
  params: { start: number; end: number },
  name?: string,
  country?: string,
  ignoreId?: string
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetListCompany({
    ...params,
    name,
    country,
    ignoreId,
  });
  return { dataListCompany: data.data.data, isLoading, refetch };
};
